import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  generateTagByLot({ commit }, params = {}) {
    commit('toggleLoading', true);
    commit('setSearchNotFoundTerms', []);

    return GraphQlClient.mutation(
      `mutation (
        $search_values: [String],
        $order_by: String!,
        $type_of_emission: String!,
        $search_by: String,
        $order_asc_desc: String!)
        {
        generateTagByLot(
          search_values: $search_values,
          type_of_emission: $type_of_emission,
          order_by: $order_by,
          order_asc_desc: $order_asc_desc,
          search_by: $search_by)
          {
            type_of_emission,
            response_text,
            search_not_found {
              search,
              message
            }
          }
      }`, params)
      .then((res) => {
        const { data = {} } = res || {};
        const { generateTagByLot = {} } = data || {};

        commit('toggleLoading', false);
        commit('setSearchNotFoundTerms', generateTagByLot.search_not_found);

        ScToast.open({ message: generateTagByLot.response_text, duration: 5000, type: 'is-success' });
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  generateTagByData({ commit }, params = {}) {
    const {
      date_range,
      volume_state,
      ...newParams
    } = params;

    const {
      start: start_date,
      end: end_date,
    } = date_range;

    const param = Object.assign(newParams,
      { start_date,
        end_date,
        volume_state: volume_state.map(item => item.value),
      });

    commit('toggleLoading', true);

    return GraphQlClient.mutation(
      `mutation ($order_by: String!,
        $type_of_emission: String!,
        $end_date: Date
        $start_date: Date,
        $order_asc_desc: String!,
        $volume_state: [Int])
        {
        generateTagByDate(
          type_of_emission: $type_of_emission,
          start_date: $start_date,
          end_date:$end_date,
          order_by: $order_by,
          volume_state: $volume_state
          order_asc_desc: $order_asc_desc ) {
          type_of_emission
        }
      }`, param)
      .then((res) => {
        commit('toggleLoading', false);
        ScToast.success('O arquivo com as etiquetas está sendo gerado, assim que finalizado estará disponível na seção Meus Arquivos.');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/generate-tag/store/actions.js